import RetailerRepresentativeCreate from './RetailerRepresentativeCreate'
import RetailerRepresentativeEdit from './RetailerRepresentativeEdit'
import RetailerRepresentativeList from './RetailerRepresentativeList'
import AccountBoxIcon from '@mui/icons-material/AccountBox'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: RetailerRepresentativeList,
    create: RetailerRepresentativeCreate,
    edit: RetailerRepresentativeEdit,
    icon: AccountBoxIcon
}
